export default __webpack_public_path__ + "static/media/fsk-18-a.8b838fc0.jpg";